import Vue from 'vue';

import { heroSlider } from '../../components/swiper-slider/_swiper-controller';
import Home from './Home.vue';

new Vue({
  render: h => h(Home),
}).$mount('#home-root');

if (document.querySelector('.js-hero-banner-swiper')) {
  heroSlider();
}
